export const COUNTRY_FULL_NAME={
  'US':'United States',
  'FR':'France',
  'DE':'Germany',
  'CA':'Canada',
  'AU':'Australia',
  'UK':'the United Kingdom'
}
